import http from '@/js/helpers/http';

/**
 * Объект необходимый для формирования партнерских ссылок
 * @param data
 * @param { string } data.url
 * @param { string } data.image
 * @param { string } data.title
 * @param { string } data.source
 * @returns {*}
 */
export default (data = {}) => http.get('/local/components/book24/widget.partner.link.generator/ajax.php', data);
